exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__aspect-r___2Wp2T{display:inline-block;position:relative;width:100%;height:100%}.index-module__aspect-r___2Wp2T iframe{position:absolute;width:100%;height:100%;left:0;top:0;border-radius:5px}", ""]);

// exports
exports.locals = {
	"aspect-r": "index-module__aspect-r___2Wp2T"
};